import styled from 'styled-components'
import { TablePagination } from '@material-ui/core'

export default styled(TablePagination)`
  background-color: ${(props) => props.theme.palette.grey[300]};

  .MuiTablePagination-toolbar {
    min-height: 32px;
  }

  .MuiToolbar-root .MuiTypography-root {
    font-size: 0.675rem;
    font-weight: bold;
  }
`
